import type { APITypes } from 'plyr-react'
import Plyr from 'plyr-react'
import React from 'react'
import { none, Option, some } from 'widgets-for-react'

export type PlyrSource = {
  type: string
  sources: {
    src: string
    provider: string
  }[]
}

export const parseMediaVideoFile = (url: string): Option<PlyrSource> => {
  function getQueryVariable(variable: any, url: URL) {
    try {
      const query = url.search.substring(1)
      const vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (decodeURIComponent(pair[0]) === variable) {
          return decodeURIComponent(pair[1])
        }
      }
      //console.log('Video query variable %s not found', variable);
    } catch (e) {}
    return undefined
  }

  let res: Option<PlyrSource> = none()

  try {
    const url1 = new URL(url)
    // Support `youtube` and `youtu.be`
    if (url1.hostname.toLowerCase().includes('youtu')) {
      let id = getQueryVariable('v', url1)
      if (id == undefined) {
        id = url1.pathname.substr(1)
      }
      res = some({
        type: 'video',
        sources: [
          {
            src: id,
            provider: 'youtube'
          }
        ]
      })
    } else if (url1.hostname.toLowerCase().includes('vimeo')) {
      let id = url1.pathname.substr(1)
      res = some({
        type: 'video',
        sources: [
          {
            src: id,
            provider: 'vimeo'
          }
        ]
      })
    } else {
      res = some({
        type: 'video',
        sources: [
          {
            src: url,
            provider: 'html5'
          }
        ]
      })
    }
  } catch (e) {}
  return res
}

export const videoUrl = (url: string) => parseMediaVideoFile(url)

export type PurePlyrProps = {
  source?: string
  key?: string
  videoRef: React.Ref<APITypes>
}

export class PurePlyr extends React.PureComponent<PurePlyrProps> {
  render() {
    let videoUrl = parseMediaVideoFile(this.props.source || '')
    return videoUrl.kind == 'l' ? (
      'Unable to load video.'
    ) : (
      <Plyr
        key={this.props.key}
        ref={this.props.videoRef}
        source={videoUrl.v as any}
        options={{
          controls: [
            'play-large', // The large play button in the center
            'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            'fast-forward', // Fast forward by the seek time (default 10 seconds)
            'progress', // The progress bar and scrubber for playback and buffering
            'current-time', // The current time of playback
            'duration', // The full duration of the media
            'mute', // Toggle mute
            'volume', // Volume control
            'settings', // Settings menu
            'fullscreen' // Toggle fullscreen
          ]
        }}
      />
    )
  }
}
